import _set from 'lodash/set';

export function setUIValueToSdkData(sdkData, sdkDataKey, uiDataVal) {
    if (uiDataVal !== undefined) {
        _set(sdkData, sdkDataKey, uiDataVal);
    }
}
